import React, { FunctionComponent } from 'react'
import { ImageSourcePropType, ImageURISource, Platform, View, ViewStyle } from 'react-native'

import { ImageContentFit } from 'expo-image'
import { isString } from 'lodash-es'
import styled from 'styled-components/native'

import { Image } from '../../atoms/image/Image'
import { IS_WEB } from '../../constants'

export interface BackgroundImageContainerProps {
  style?: ViewStyle
  backgroundImageUrl: string | number
  centerBackgroundImage?: boolean
  shouldScale?: boolean
  testID?: string
  contentFit?: ImageContentFit
}
const WebImage = styled(Image)<{
  shouldScale: boolean
  backgroundImageUrl: string | number
  centerBackgroundImage: boolean
}>(
  ({ shouldScale, backgroundImageUrl, centerBackgroundImage }) =>
    IS_WEB && {
      position: 'fixed',
      flexGrow: 1,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${backgroundImageUrl})`,
      backgroundRepeat: 'repeat',
      ...(shouldScale && {
        backgroundSize: 'cover',
      }),
      ...(centerBackgroundImage && {
        backgroundPositionX: 'center',
        backgroundPositionY: 'top',
      }),
    },
)

const ContainerNative = styled.View({
  flexGrow: 1,
})

export const BackgroundImageContainer: FunctionComponent<BackgroundImageContainerProps> = ({
  children,
  style,
  backgroundImageUrl,
  shouldScale = true,
  centerBackgroundImage = true,
  testID = 'BackgroundImageContainer',
  contentFit = Platform.OS === 'android' ? 'cover' : 'none',
}) => {
  if (IS_WEB) {
    let uri: string = ''
    // backgroundImageUrl is string on LW, and ImageURISource on 1lyra
    if (isString(backgroundImageUrl)) {
      uri = backgroundImageUrl
    } else {
      uri = (backgroundImageUrl as ImageURISource).uri ?? ''
    }

    return (
      <View style={{ flex: 1, ...style }} testID={testID}>
        <WebImage shouldScale={shouldScale} backgroundImageUrl={uri} centerBackgroundImage={centerBackgroundImage} />
        {children}
      </View>
    )
  } else {
    return (
      <ContainerNative style={style} testID={testID}>
        <Image
          source={backgroundImageUrl as ImageSourcePropType}
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          accessibilityIgnoresInvertColors
          contentPosition={{ top: '100%', left: '50%' }}
          contentFit={contentFit}
        />
        {children}
      </ContainerNative>
    )
  }
}
